import { render } from "./PattyThreadList.vue?vue&type=template&id=55c75573&scoped=true"
import script from "./PattyThreadList.vue?vue&type=script&lang=js"
export * from "./PattyThreadList.vue?vue&type=script&lang=js"

import "./PattyThreadList.vue?vue&type=style&index=0&id=55c75573&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c75573"]])

export default __exports__